import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbdModalContent_no } from '../modal/ajout-docteur/video-dr-norolala/video-dr-norolala.component';
import { NgbdModalContent_ro } from '../modal/ajout-docteur/video-dr-roland/video-dr-roland.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Message } from 'model/modal-cms/message';
import { CMSService } from '../../services/cms-service';
import Swal from 'sweetalert2';
import { AdminService } from '../../services/admin';
declare var mdtoast: any;
var success_message = mdtoast("Statistique de consultation médicale. Chargement de donnée...", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var success_message2 = mdtoast("Statistique de répos médicale. Chargement de donnée...", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var success_message3 = mdtoast("Statistique de remboursement. Chargement de donnée... ", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var success_message4 = mdtoast("Message, bien envoyer.", { duration: 5000, init: true, type: mdtoast.SUCCESS });

@Component({
  selector: 'app-medecin-ans',
  templateUrl: './medecin-ans.component.html',
  styleUrls: ['./medecin-ans.component.scss']
})
export class MedecinAnsComponent implements OnInit {
  message: Message = new Message(null);
  id_agent_actuel:any;
  constructor(private router: Router, public adminService: AdminService, private modalService: NgbModal,private cMSService : CMSService) {
         this.id_agent_actuel = this.adminService.getUserIMIscrit();
   }

  ngOnInit() {
  }

 
  Evaluation(id:any){    
    this.router.navigate(['evaluation/'+id]);
  }

  open(id_dr:any){
    if (id_dr == 1) {
      const modalRef = this.modalService.open(NgbdModalContent_no);
    modalRef.componentInstance.name = 'modal-content';
    }else   if (id_dr == 2) {
      const modalRef = this.modalService.open(NgbdModalContent_ro);
    modalRef.componentInstance.name = 'modal-content';
    }
  }


  EnvoyerMessage(tel,mail,contenu){
    Swal.fire({
      title: 'Envoi message',
      icon: 'info',
      text: contenu,
      // icone: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Oui, Envoyer!',
      cancelButtonText: 'Non'
    }).then((result) => {
      if (result.value) {
        //ok btn
        this.message.im_dest= this.id_agent_actuel       
        this.message.etat_mess ="c"
       this.message.tel_dest = tel;
       this.message.mail_dest = mail;
       this.message.date_mess = new Date();
       this.message.contenue_mess = contenu;
        this.cMSService.saveMessage(this.message)
        .subscribe(data => {
          success_message4.show();  
        }, err => {
          // console.log(JSON.parse(err._body).message);

        })



      

      } else if (result.dismiss === Swal.DismissReason.cancel) {
      //cancel btn
      }
    });

  }

}
